import React from 'react'
import PropTypes from 'prop-types'

function Tiles({ as: Comp = 'div', children, minSize = 10, gutter = 1, ...rest }) {
  // https://codepen.io/bradwestfall/pen/qLJoqK
  // The reason for wrapping in an arbitrary div is for one, we need to ensure
  // the first child of grid is under our control without affecting the children
  // passed in, but also grid items will grow vertically to the height of their
  // row siblings, we might not want that for the children passed in, but we can
  // do that to our arbitrary div

  const style = {
    display: 'grid',
    gridGap: `${gutter}em`,
    // https://css-tricks.com/intrinsically-responsive-css-grid-with-minmax-and-min/
    gridTemplateColumns: `repeat(auto-fill, minmax(min(${minSize}em, 100%), 1fr))`,
  }

  return (
    <Comp {...rest} className="tiles" style={style}>
      {React.Children.map(children, (child) => (
        <div>{child}</div>
      ))}
    </Comp>
  )
}

Tiles.propTypes = {
  minSize: PropTypes.number,
}

export default Tiles
